import { useMemo } from "react";
import { PencilIcon, TrashIcon } from "@heroicons/react/24/outline";
import DataGrid from "../../../components/Datagrid";

export default function PermissionsList({
  permissions,
  loading,
  onEdit,
  onDelete,
}) {
  const columns = useMemo(
    () => [
      {
        key: "code",
        label: "Code",
        width: 320,
        format: (v) => <span className="font-semibold">{v}</span>,
      },
      { key: "name", label: "Nom", width: 320 },
      {
        key: "description",
        label: "Description",
        format: (v) => <div className="max-w-xs truncate">{v}</div>,
      },
      {
        key: "actions",
        label: "",
        width: 120,
        render: (row) => (
          <div className="px-4 py-3 flex gap-3 justify-end">
            <button
              type="button"
              onClick={(e) => {
                e.stopPropagation();
                onEdit(row);
              }}
              className="p-2 rounded-full hover:bg-gray-100 transition"
            >
              <PencilIcon className="w-5 h-5 text-gray-700" />
            </button>

            <button
              type="button"
              onClick={(e) => {
                e.stopPropagation();
                onDelete(row);
              }}
              className="p-2 rounded-full hover:bg-gray-100 transition"
            >
              <TrashIcon className="w-5 h-5 text-red-600" />
            </button>
          </div>
        ),
      },
    ],
    [onEdit, onDelete]
  );

  const data = useMemo(() => {
    return (permissions || []).map((p, idx) => ({
      ...p,
      id: p.id ?? `${p.code ?? "perm"}-${idx}`,
      actions: "",
    }));
  }, [permissions]);

  return (
    <DataGrid
      columns={columns}
      data={data}
      loading={loading}
      emptyMessage="Aucune permission trouvée."
    />
  );
}
